import { render, staticRenderFns } from "./SendGratification.vue?vue&type=template&id=31bee344&scoped=true"
import script from "./SendGratification.vue?vue&type=script&lang=js"
export * from "./SendGratification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bee344",
  null
  
)

export default component.exports